const ALL_DEPARTMENTS_ID = 0
export { BENEFITS } from './benefits'
export { ALL_DEPARTMENTS_ID }
